import { render, staticRenderFns } from "./deleteCurd.vue?vue&type=template&id=46f6b0c7&"
import script from "./deleteCurd.vue?vue&type=script&lang=js&"
export * from "./deleteCurd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports